import { Component } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

interface Crumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: "breadcrumb.component.html",
  styleUrl: 'breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  items: Crumb[] = [];
  private history: Crumb[] = [];

  constructor(private router: Router, private _location: Location) {
    this.router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.addToHistory(e.urlAfterRedirects);
      }
    });
    this.addToHistory(this.router.url);
  }

  private addToHistory(fullUrl: string) {
    const url = fullUrl.split('?')[0];
    if (url.includes('/secure/unauthorized')) {
      return;
    }

    // same as current last → just refresh previous list
    if (this.history.length && this.history[this.history.length - 1].url === url) {
      const prev = this.history.slice(0, -1);
      this.items = prev.slice(-3);
      return;
    }

    const label = this.formatLabel(url);

    // move existing entry to end (keep chronological uniqueness)
    this.history = this.history.filter(c => c.url !== url);
    this.history.push({ label, url });

    // exclude current (last) from visible crumbs, show up to 3 previous
    const prev = this.history.slice(0, -1);
    this.items = prev.slice(-3);
  }

  private formatLabel(url: string): string {
    let seg = url.split('/').filter(Boolean).pop() || 'Home';
    const segPrev = url.split('/').filter(Boolean).slice(-2, -1)[0] || '';
    const segPrev2 = url.split('/').filter(Boolean).slice(-3, -2)[0] || '';
 
    if (!isNaN(Number(seg))) {
      if (!isNaN(Number(segPrev))) {
        seg = segPrev2
      } else {
        seg = segPrev + " " + seg;
      }
    }
    return seg
      .replace(/-/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  goBack() {
    this._location.back();
  }
}